import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';
import { Step7 } from '../../../../shared/models/component-messages/diveIN/step7';
import { TypeOuiNon } from '../models/TypeOuiNon';

@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNon';
  @Input() parentForm: FormGroup;
  @Input() eligibleMPS: TypeOuiNon;
  @Input() disabled: boolean;
  @Input() labelRadio: string;
  @Input() value: String;

  public step7 = new Step7();
  
  radioButtonValue;
  radioButtonCtrlName;
  oui = true;
  non = false;

  constructor() {
  }

  public ngOnInit() {
    
		if (this.eligibleMPS?.oui) {
			this.radioButtonValue = this.oui;
		}	else {
			this.radioButtonValue = this.non;
		}

		this.radioButtonCtrlName = this.getUid() + '_SepAtt_oui';
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

